<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :before-close="closeModal">

    <br>
    <div>
      <label>Affiliate: </label> {{ affiliateName }} <br>
      <label>Balance: </label> {{ cardBalance }}
    </div>


    <br>
    <el-tabs v-model="activeTab" @tab-click="handleClick">

      <el-tab-pane :label="'Load'" name="Load">
        <fg-input type="number"
                  label="Amount"
                  placeholder="$"
                  v-model="loadAmount"
                  @keyup.enter="load()"/>
      </el-tab-pane>


      <el-tab-pane label="Unload" name="Unload">
        <fg-input type="number"
                  label="Amount"
                  placeholder="$"
                  v-model="unloadAmount"
                  @keyup.enter="unload()"/>
      </el-tab-pane>

    </el-tabs>

    <span slot="footer" class="dialog-footer">
      <button class="btn" @click="closeModal()">Cancel</button>&nbsp;
      <button class="btn btn-success" :disabled="(activeTab == 'Load' && !Number(loadAmount)) || activeTab == 'Unload' && !Number(unloadAmount)"
                                      @click="confirm()">{{ activeTab }}
      </button>
    </span>
  </el-dialog>
</template>

<script>
import { PaymentCard } from 'src/classes/datamodel.js'
import utils from '../../utils.js'
export default {
  components: {},
  name: 'Payment-Card-Balance-Modal',
  data () {
    return {
      selectedTab: 'Load',
      closing: false, // without this, the tab changes every time the modal is opened in Close/Lost mode
      // dateExpiration: '',
      loadAmount: 0,
      unloadAmount: 0
    }
  },
  computed: {
    mode () {
      return this.$store.getters.modal.mode
    },
    title () {
      return this.mode + ' Payment Card' // ADD 's' when multiple leads selected
    },
    visible () {
      return this.$store.getters.modal.current == 'Payment Card Balance'
    },
    modalObject () {
      return this.$store.getters.modal.object || {}
    },
    affiliateName () {
      // console.log('getters.getAffiliateName = ', this.$store.getters.getAffiliateName)
      return this.$store.getters.getAffiliateName(this.modalObject.affiliateAccountId)
    },
    cardBalance () {
      return this.modalObject.paymentCardBalance
    },
    dateExpiration: {
      get () {
        console.log('get() dateExpiration: ', utils.dateToString(this.paymentCard.dateExpiration))
        if (!this.paymentCard.dateExpiration || typeof this.paymentCard.dateExpiration != 'object'
                                             || this.paymentCard.dateExpiration.constructor.name != 'Date'
                                             || !this.paymentCard.dateExpiration.getTime()) {
          return undefined
        }
        else {
          return utils.dateToString(this.paymentCard.dateExpiration)
        }
      },
      set (date) {
        console.log('date = ', date)
        this.paymentCard.dateExpiration = new Date(date)
      }
    },
    activeTab: { // TODO (?): WHEN CLOSING MODAL, MESSES UP THE ACTIVATE TAB FOR NEXT OPEN_MODAL
      get () {
        if (this.selectedTab) {
          return this.selectedTab
        }
        else {
          return this.showReceivedTab ? 'Received' : 'Edit'
        }
      },
      set (tab) {
        if (!this.closing) {
          this.selectedTab = tab
        }
      }
    },
  },
  methods: {
    async confirm () {
      this.activeTab == 'Load' ? this.load() : this.unload()
      this.loadAmount = 0
      this.unloadAmount = 0
    },
    async load () {
      const obj = this.modalObject
      const res = await this.$store.dispatch('loadPaymentCard', { paymentCardId: obj.id,
                                                                  paymentCardProviderId: obj.paymentCardProviderId,
                                                                  amount: Number(this.loadAmount) || 0,
                                                                  affiliateAccountId: this.modalObject.affiliateAccountId })
      if (res) {
        if (res.errors) {
          console.log('res.errors = ', res.errors)
          if (!res.errors[0] || typeof res.errors[0] != 'string' || !res.errors[0].toLowerCase().includes('session')) {
            this.$notify({ errorMessage: res.errors[0] })
          }
        }
        else {
          this.$notify({ successMessage: 'Done!'})
          this.$store.dispatch('fetchBaseData')
          this.closeModal()
        }
      }
      else {
        this.$notify({ errorMessage: 'Something went wrong...'})
      }
    },
    async unload () {
      const obj = this.modalObject
      const res = await this.$store.dispatch('unloadPaymentCard', { paymentCardId: obj.id,
                                                                    paymentCardProviderId: obj.paymentCardProviderId,
                                                                    amount: Number(this.unloadAmount),
                                                                    affiliateAccountId: this.modalObject.affiliateAccountId })
      if (res) {
        if (res.errors) {
          if (!res.errors[0] || typeof res.errors[0] != 'string' || !res.errors[0].toLowerCase().includes('session')) {
            this.$notify({ errorMessage: res.errors[0] })
          }
        }
        else {
          this.$notify({ successMessage: 'Done!'})
          this.$store.dispatch('fetchBaseData')
          this.closeModal()
        }
      }
      else {
        this.$notify({ errorMessage: 'Something went wrong...'})
      }

    },
    closeModal () {
      this.closing = true
      if (this.$store.getters.selectedObjectsJson) {
        this.$store.commit('STOP_SELECT_OBJECTS')
      }
      
      this.$store.dispatch('closeModal').then(function() {
        if (this) {
          this.closing = false
          this.selectedTab = ''
        }
      })
    },
    handleClick (tab, event) {
      console.log('tab.name = ', tab.name)
      // console.log('event = ', event)
      this.selectedTab = tab.name
    }
  },
  watch: {
    visible: function (elem) {
      if (this.visible) {
        // console.log('this.$refs.tofocus.$el.children = ', this.$refs.tofocus.$el.children)
        // doesn't work without the timeout..
        // setTimeout(() => this.$refs.tofocus.$el.children[0].focus(), 500)
        // this.$refs.tofocus.$el.children[0].focus()
      }
    }
  }
}
</script>

<style>

</style>